module.exports = __webpack_public_path__ + "assets/img/radiotherapy-detail-head-back.496f6cda.png";